import { ApiRepository, RepositoryResponse } from "@ic-anywhere/ic-dal";
import { InvitationRequestResponseDto } from "./invitationRequest.typings";

export const EVENTS_URL = "/2.0/events";

export const getInvitationRequest = async (
  repo: ApiRepository,
  eventId: string
): Promise<RepositoryResponse<InvitationRequestResponseDto>> => {
  return await repo.get<InvitationRequestResponseDto>(`${EVENTS_URL}/${eventId}/my-invitation-requests`);
};

export const createInvitationRequest = async (repo: ApiRepository, eventId: string): Promise<void> => {
  await repo.post(`${EVENTS_URL}/${eventId}/my-invitation-requests`, {});
};

export const deleteInvitationRequest = async (
  repo: ApiRepository,
  eventId: string,
  invitationRequestId: string
): Promise<void> => {
  await repo.delete(`${EVENTS_URL}/${eventId}/my-invitation-requests/${invitationRequestId}`);
};
